import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

/**
 * Confirmation for destructive actions, replacing the browser's `confirm()`.
 *
 * Three call sites delete a case — cases, case-details and the partner-details
 * Cases tab — and all three used the native dialog, which cannot be styled,
 * blocks the whole tab, and looks like a browser warning rather than part of the
 * app. MatDialog was imported for this and never opened.
 *
 * Declarative rather than a service: with three call sites, an overlay service
 * would be more machinery than the thing it replaces. If a fourth appears, the
 * upgrade path is CDK Overlay.
 */
@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {

  @Input() isOpen = false;
  @Input() title = 'Are you sure?';
  @Input() message = '';
  @Input() confirmLabel = 'Confirm';
  @Input() cancelLabel = 'Cancel';
  /** A .dl-btn modifier: destructive actions pass 'dl-btn--danger'. */
  @Input() confirmClass = 'dl-btn--primary';
  /** Keeps the dialog up, and the buttons disabled, while the request runs. */
  @Input() busy = false;

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.isOpen && !this.busy) {
      this.cancel.emit();
    }
  }
}
